<template>
  <div
    :class="[{ 'boss-new': member.isNew },{ 'pega-input': isShowCheckbox }]"
    class="boss-resumecard-item-left"
    data-test="resumecard-avatar"
    @click="isShowCheckbox ? $emit('change', id) : ''"
  >
    <div class="text-center">
      <span style="display: inline-flex">
        <input
          v-if="isShowCheckbox"
          :id="'is-selected-'+id"
          :checked="check"
          :value="id"
          type="checkbox"
          style="margin-top:2px"
          class="boss-userid pega-resumecard-check pega-input"
          data-test="is-selected"
        >
        <label
          class="boss-userid-text pega-resumecard-id pega-input"
          data-test="user-id"
        >ID:{{ member.id }}
        </label>
      </span>
    </div>
    <div class="boss-resumecard-item-left-item">
      <div class="boss-avatar">
        <template v-if="isScouted && !isMasking">
          <span
            :class="[isReadScout? 'boss-read':'boss-unread']"
            data-test="is-read-scout"
          />
        </template>
        <img
          v-if="isNew"
          class="boss-avatar-image"
          data-test="boss-avatar-new"
          src="@/assets/images/boss-avatar-new.svg"
          alt="24時間以内"
        >
        <img
          v-else
          class="boss-avatar-image"
          data-test="boss-avatar"
          src="@/assets/images/boss-avatar.svg"
          alt="90日以上無し"
        >
      </div>
      <div class="boss-latest-action">
        <div class="boss-resumecard-head">
          最終ログイン
        </div>
        <div
          :class="{'boss-over-days': !isNew}"
          class="boss-resumecard-date"
          data-test="member_last_activity"
        >
          {{ lastActivityLabel | loadLoginLabel }}
        </div>
      </div>
      <div class="boss-another-scout">
        <div
          v-tooltip="{ content: '7日以内にこの会員をスカウトした他社企業数です。'}"
          class="boss-resumecard-head"
        >
          スカウト社数
        </div>
        <div
          class="boss-resumecard-date"
          data-test="approached-count"
        >
          {{ member.approachedCount | parseApproachedCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pega-resumecard-id {
  margin-bottom: 5px;
  position: initial;
}
.pega-resumecard-check {
  vertical-align: initial;
}
label > input {
  cursor: pointer;
}
</style>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'

export default {
  filters: {
    loadLoginLabel (label) {
      return label || '...'
    },
    parseApproachedCount (val) {
      return (!val) ? '0社' : (val < 50) ? `${val}社` : '50社以上'
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    member: {
      type: Object,
      required: true
    },
    checked: {
      type: Array,
      default: () => ([])
    },
    isShowCheckbox: {
      type: Boolean,
      default: true
    },
    isScouted: {
      type: Boolean,
      default: false
    },
    isScoutDecline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scouts: ''
    }
  },
  computed: {
    check () {
      return _.includes(this.checked, this.id)
    },
    lastActivityLabel () {
      if (this.member.isEntry) return '応募済み'
      if (this.member.isScoutExcluded) return '除外済み'
      if (this.member.withdrawDate) return '退会済み'
      if ((this.member.subscriptions && !this.member.subscriptions.scout) || this.member.isScoutRejection) return '利用停止'
      // このコンポーネントでは求人・契約情報を持てないため、辞退判定が必要な場合はprops渡してもらう
      if (this.isScoutDecline) return '辞退'
      const lastActivityDatetime = this.lastActivityDatetime
      if (!lastActivityDatetime) return ''

      const DIFF_DAYS = this.dateDiff(lastActivityDatetime)
      const DIFF_HOURS = this.hourDiff(lastActivityDatetime)

      if (DIFF_HOURS <= 24) {
        return Math.ceil(DIFF_HOURS) + '時間以内'
      } else if (DIFF_DAYS === 1) {
        return '昨日'
      } else if (DIFF_DAYS <= 90) {
        return DIFF_DAYS + '日前'
      } else if (DIFF_DAYS >= 91) {
        return '90日以内無し'
      } else {
        return ''
      }
    },
    lastActivityDatetime () {
      return dayjs(this.member.recentActionDate, 'YYYY/MM/DD hh:mm:ss')
    },
    isReadScout () {
      return !!(_.get(this.member, 'scout.latestMessage.readDate'))
    },
    isNew () {
      return dayjs(dayjs().subtract(10, 'days')).isSameOrBefore(this.lastActivityDatetime, 'day')
    },
    isMasking () {
      return (this.member.subscriptions && !this.member.subscriptions.scout) || this.member.isScoutRejection || this.member.withdrawDate
    }
  },
  methods: {
    dateDiff (dateObject) {
      const date = dayjs(dateObject).startOf('day')
      const now = dayjs().startOf('day')

      return now.diff(date, 'day')
    },
    hourDiff (dateObject) {
      const date = dayjs(dateObject, 'YYYY/MM/DD hh:mm:ss')
      const now = dayjs()

      return now.diff(date, 'hours', true)
    }
  }
}
</script>
